import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

export function EmptyStateNoMeeting() {
    return (
        <EmptyStateLarge
            title='Select a meeting to view a report'
            subtitle='Choose a meeting from the filter above to see stats and trends'
            icon={<Illustration src='calendar-lady' width={320} />}
        />
    );
}
